(function () {
  "use strict";

  const targetSelector = "[data-home-cart-animation-target]";
  const mobileQuery = window.matchMedia("(max-width: 1149px)");
  const reducedMotionQuery = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  );

  let previousCart = null;
  let previousCount = null;
  let lastSourceImage = null;
  let hasHandledChange = false;

  function cartTarget() {
    return document.querySelector(targetSelector);
  }

  function isEnabled() {
    return mobileQuery.matches && cartTarget();
  }

  function itemImage(item) {
    if (!item) return "";
    if (typeof item.image === "string") return item.image;
    if (item.featured_image) {
      return item.featured_image.url || item.featured_image.src || "";
    }
    return "";
  }

  function itemIdentity(item) {
    return String(item && (item.key || item.variant_id || item.id || ""));
  }

  function changedItem(currentCart, direction) {
    if (!currentCart || !Array.isArray(currentCart.items)) return null;
    if (!previousCart || !Array.isArray(previousCart.items)) {
      return currentCart.items[0] || null;
    }

    const currentById = new Map(
      currentCart.items.map(function (item) {
        return [itemIdentity(item), Number(item.quantity) || 0];
      }),
    );
    const previousById = new Map(
      previousCart.items.map(function (item) {
        return [itemIdentity(item), Number(item.quantity) || 0];
      }),
    );
    const candidates =
      direction === "add" ? currentCart.items : previousCart.items;

    return (
      candidates.find(function (item) {
        const id = itemIdentity(item);
        const before = previousById.get(id) || 0;
        const after = currentById.get(id) || 0;
        return direction === "add" ? after > before : after < before;
      }) || candidates[0] || null
    );
  }

  function sourceImageFrom(element) {
    if (!element || !element.closest) return null;
    const product = element.closest(
      "hdt-card-product, .hdt-card-product, [data-product-id], .cart-item, [data-cart-item], hdt-sticky-btn-atc, .hdt-main-product, .hdt-product-info__list, wrapp-hdt-pr-frm",
    );
    if (!product) return null;

    const cardImg = product.querySelector(
      ".hdt-card-product__media--main, [update-img]",
    );
    if (cardImg) return cardImg;

    // PDP: sticky thumb is often hidden on mobile — prefer visible gallery image
    const isPdp =
      product.matches(
        "hdt-sticky-btn-atc, .hdt-main-product, .hdt-product-info__list, wrapp-hdt-pr-frm",
      ) || product.closest(".hdt-main-product, hdt-sticky-btn-atc");
    if (isPdp) {
      const galleryImg = document.querySelector(
        ".hdt-product-media__main .hdt-slider__slide.is-selected img, .hdt-product-media__main .hdt-slider__slide:not([hidden]) img, .hdt-product-media__main img",
      );
      if (galleryImg) return galleryImg;
      const stickyImg = document.querySelector(".hdt-sticky-atc__img img");
      if (stickyImg) return stickyImg;
    }

    return product.querySelector("img");
  }

  // PDP: center of the product gallery. Other pages: center of the screen.
  function flyOrigin() {
    const pdpMedia = document.querySelector(
      ".hdt-main-product .hdt-product-media__main",
    );
    if (pdpMedia) {
      const rect = pdpMedia.getBoundingClientRect();
      const top = Math.max(rect.top, 0);
      const bottom = Math.min(rect.bottom, window.innerHeight);
      const left = Math.max(rect.left, 0);
      const right = Math.min(rect.right, window.innerWidth);
      if (bottom > top && right > left) {
        return { x: (left + right) / 2, y: (top + bottom) / 2 };
      }
    }
    return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  }

  // Blink fill is owned solely by Shopify.cartBtnAnimation — do not call it here.
  function animateProduct(imageUrl, direction) {
    const target = cartTarget();
    if (!target) return;
    if (reducedMotionQuery.matches || !imageUrl) return;

    const targetRect = target.getBoundingClientRect();
    const targetCenter = {
      x: targetRect.left + targetRect.width / 2,
      y: targetRect.top + targetRect.height / 2,
    };
    const origin = flyOrigin();
    const start = direction === "add" ? origin : targetCenter;
    const end = direction === "add" ? targetCenter : origin;

    const flyer = document.createElement("img");
    flyer.className =
      "hdt-home-cart-flyer hdt-home-cart-flyer--" + direction;
    flyer.src = imageUrl;
    flyer.alt = "";
    flyer.setAttribute("aria-hidden", "true");
    flyer.style.setProperty("--fly-start-x", start.x + "px");
    flyer.style.setProperty("--fly-start-y", start.y + "px");
    flyer.style.setProperty("--fly-end-x", end.x + "px");
    flyer.style.setProperty("--fly-end-y", end.y + "px");
    document.body.appendChild(flyer);
    flyer.addEventListener(
      "animationend",
      function () {
        flyer.remove();
      },
      { once: true },
    );
  }

  function handleCart(cart) {
    if (!cart || typeof cart.item_count !== "number") return;

    const currentCount = cart.item_count;
    if (previousCount === null) {
      previousCount = currentCount;
      previousCart = cart;
      return;
    }

    hasHandledChange = true;
    // Skip fly while cart drawer is open — qty +/- already updates in-place
    const drawerOpen =
      typeof Shopify !== "undefined" &&
      typeof Shopify.isCartDrawerOpen === "function" &&
      Shopify.isCartDrawerOpen();
    if (isEnabled() && !drawerOpen && currentCount !== previousCount) {
      const direction = currentCount > previousCount ? "add" : "remove";
      const item = changedItem(cart, direction);
      animateProduct(
        itemImage(item) || lastSourceImage?.currentSrc,
        direction,
      );
    }

    previousCount = currentCount;
    previousCart = cart;
    lastSourceImage = null;
  }

  document.addEventListener(
    "pointerdown",
    function (event) {
      lastSourceImage = sourceImageFrom(event.target);
    },
    true,
  );

  document.addEventListener("cart:change", function (event) {
    handleCart(event.detail && event.detail.cart);
  });

  document.addEventListener("cart:refresh", function (event) {
    handleCart(event.detail && event.detail.cart);
  });

  const initialTarget = cartTarget();
  const initialCounter =
    initialTarget && initialTarget.querySelector("hdt-cart-count");
  const initialCount = initialCounter
    ? Number.parseInt(initialCounter.textContent, 10)
    : NaN;
  if (Number.isFinite(initialCount)) previousCount = initialCount;

  fetch("/cart.js")
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (cart) {
      if (!hasHandledChange && cart) {
        previousCart = cart;
        previousCount = cart.item_count;
      }
    })
    .catch(function () {});
})();
